module.exports = __webpack_public_path__ + "static/img/anxun42.9f45328e.png";